export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <div
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://i.ibb.co/TMsvh7wH/IMG-3557-1.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full pt-32 pb-20 animate-slide-up">
        <div className="inline-block mb-6">
          <span className="bg-primary/20 border border-primary/40 text-primary px-5 py-2 rounded-full text-sm font-bold backdrop-blur-sm">
            <i className="ri-shield-check-fill mr-2"></i>
            NAPIT Approved & Fully Insured
          </span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 font-display leading-tight">
          Professional Electricians in
          <br />
          <span className="text-primary">Bridgend</span>
        </h1>

        <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
          Fast, Reliable & Fully Certified Electrical Services for Homes and Businesses Across Bridgend and South Wales
        </p>

        <div className="flex flex-wrap justify-center items-center gap-4 mb-10">
          <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/10">
            <i className="ri-shield-check-fill text-primary text-xl mr-2"></i>
            <span className="text-white font-semibold text-sm">NAPIT Approved</span>
          </div>
          <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/10">
            <i className="ri-star-fill text-primary text-xl mr-2"></i>
            <span className="text-white font-semibold text-sm">5-Star Rated</span>
          </div>
          <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/10">
            <i className="ri-time-fill text-primary text-xl mr-2"></i>
            <span className="text-white font-semibold text-sm">24/7 Emergency</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:01656497474"
            className="bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 hover:shadow-2xl cursor-pointer whitespace-nowrap inline-block animate-pulse-glow"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call Now: 01656 497474
          </a>
          <button
            onClick={scrollToContact}
            className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/20 px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 hover:shadow-2xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-fill mr-2"></i>
            Get Free Quote
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-primary text-4xl"></i>
      </div>
    </section>
  );
}
